import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatCheckboxChange, MatPaginator, MatTableDataSource } from '@angular/material';
import { Product } from '../../../interfaces/product';
import { ProductsService } from '../../../services/products.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { LoggerService } from '../../../services/logger.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/finally';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-loyalization-list',
  templateUrl: './loyalization-list.component.html',
  styleUrls: ['./loyalization-list.component.scss']
})
export class LoyalizationListComponent implements OnInit, OnDestroy {
  @ViewChild('paginator')
  paginator: MatPaginator;
  public dataSource: MatTableDataSource<Product>;
  public isLoadingResults = false;
  public displayedColumns = ['checkbox', 'name', 'type', 'aliases'];
  public products: Product[];
  public selectedProducts: Product[] = [];
  public isLoyalizable = false;
  public subscription: Subscription = new Subscription();
  public filter: object;
  @Input()
  productTableName: string;

  constructor(
    private productsService: ProductsService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastsManager,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.setTableParameters();
    this.fetchProducts();
    this.subscription.add(
      this.productsService.currentTriggeredTableSubject$.subscribe(productTableName => {
        if (productTableName && productTableName !== this.productTableName) {
          this.fetchProducts();
          this.productsService.currentTriggeredTableSubject$.next('');
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.productsService.currentTriggeredTableSubject$.next('');
  }

  setTableParameters(): void {
    if (this.productTableName === 'loyalizationTable') {
      this.isLoyalizable = true;
      this.filter = { isLoyalizable: true };
    } else {
      this.filter = {};
    }
  }

  isSelected(product): boolean {
    return this.selectedProducts.some(selectedProducts => {
      return selectedProducts.id === product.id;
    });
  }

  fetchProducts(): void {
    this.isLoadingResults = true;
    this.productsService.getProducts(this.filter).subscribe(
      products => {
        this.products = products;
        this.dataSource = new MatTableDataSource(products);
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      },
      error => {
        LoggerService.log('ProductListComponent::ngOnInit', error);
        this.toastr.error(this.translate.instant('LOYALIZATION_LIST.COMPONENT.DATA_DOWNLOAD_ERROR'));
      }
    );
  }

  updateProducts(selectedProducts: Product[], isLoyalizable: boolean): void {
    const requests = [];
    selectedProducts.forEach(product => {
      requests.push(this.productsService.updateProduct(product.id, product));
    });
    this.isLoadingResults = true;
    forkJoin(requests)
      .finally(() => {
        this.isLoadingResults = false;
        this.selectedProducts = [];
      })
      .subscribe(
        () => {
          this.productsService.currentTriggeredTableSubject$.next(this.productTableName);
          this.fetchProducts();
        },
        error => {
          LoggerService.log('ProductEditComponent::saveProduct', error);
          this.toastr.error(this.translate.instant('LOYALIZATION_LIST.COMPONENT.PRODUCT_UPDATE_ERROR'));
        },
        () => {
          if (isLoyalizable) {
            this.toastr.info(this.translate.instant('LOYALIZATION_LIST.COMPONENT.LOYALTY_POSSIBILITY_ADDED'));
          } else {
            this.toastr.info(this.translate.instant('LOYALIZATION_LIST.COMPONENT.LOYALTY_POSSIBILITY_REMOVED'));
          }
        }
      );
  }

  setLoyalization(selectedProducts: Product[], isLoyalizable: boolean): Product[] {
    return selectedProducts.map(product => {
      product.isLoyalizable = isLoyalizable;
      return product;
    });
  }

  changeProductLoyalization(isLoyalizable: boolean): void {
    this.setLoyalization(this.selectedProducts, isLoyalizable);
    this.updateProducts(this.selectedProducts, isLoyalizable);
  }

  stopPropagination(e): void {
    e.stopPropagation();
  }

  applyFilter(filterValue: string): void {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  selectProduct(event: MatCheckboxChange, product: Product, selectedProducts: Product[]): Product[] {
    if (event.checked) {
      selectedProducts.push(product);
      return selectedProducts;
    }
    return selectedProducts.splice(selectedProducts.indexOf(product), 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/loyalization/loyalization-list/loyalization-list.component.ts